<template>
  <div class="page" id="credits-buy">
    <div class="card">
      <div class="header">
        <div class="description">
          <h2 class="title">ASSINATURA</h2>
          <p class="subtitle">Preencha os dados para pagamento da assinatura.</p>
        </div>
      </div>

      <div class="body -not-finished" v-if="!finished && !notFound">
        <table>
          <thead>
          <tr>
            <th>Nome do Plano</th>
            <th>Valor por Consulta</th>
            <th>Valor do Plano</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{ plan.name }}</td>
            <td>R$ {{ plan.price_per_consultation | currency }}</td>
            <td>R$ {{ plan.price / 100 }}</td>
          </tr>
          </tbody>
        </table>


        <form id="payment-form" @submit.prevent="">
          <div class="form-group choose-payment-method">
            <div class="paymentOptions">
              <label class="form-check option">
                <input id="typeCreditCard" name="type" type="radio" class="form-check-input" value="a" v-model="type">
                <span class="icon"><ion-icon name="card"></ion-icon></span>
                Adicionar forma de pagamento
              </label>
              <label class="form-check option">
                <input id="typeBoleto" name="type" type="radio" class="form-check-input" value="s" v-model="type">
                <span class="icon"><ion-icon name="wallet"></ion-icon></span>
                Selecionar cartão de crédito
              </label>
            </div>
          </div>

          <div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-3" role="alert"  v-show="paymentErrorMessage">
            <span class="block sm:inline">{{ paymentErrorMessage }}</span>
            <span class="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
          </div>

          <div v-if="type === 'a'">
            <div id="payment-element"></div>
          </div>

          <div class="form-group" :class="{'-has-error': selectPaymentMethod}" v-if="type === 's'">
            <label for="credit-card" class="label">Cartão de Crédito</label>
            <select
              name="credit-card"
              id="credit-card"
              class="form-control"
              v-model="creditCard"
              required
            >
              <option value="">Selecione o cartão de crédito...</option>
              <option v-for="card in paymentMethods" :value="card.id">{{ card.card.brand.toUpperCase() }} ****{{ card.card.last4 }}</option>
            </select>

            <p class="description" v-if="selectPaymentMethod">Selecione o cartão de crétito.</p>
          </div>

          <button class="btn btn-primary -full-width mt-5" @click="subscribe">
            <div class="spinner hidden" id="spinner"></div>
            <span id="button-text">Assinar</span>
          </button>
        </form>
      </div>

      <div class="body -finished" v-if="finished">
        <success-checkmark/>

        <h2 class="title">Sua assinatura está sendo processada</h2>
        <p class="description">
          Sua assinatura ficará disponível assim que o pagamento for aprovado.
        </p>
        <div class="actions">
          <router-link
            :to="{name: 'PlanDetail'}"
            class="btn btn-primary"
          >Visualizar os detalhes da sua assinatura
          </router-link>
        </div>
      </div>

      <div class="body -finished" v-if="notFound">
        <success-checkmark/>

        <h2 class="title">Plano não encontrado</h2>
        <p class="description">
          Este plano não existe, consulte os planos disponiveis clicando no botão abaixo
        </p>
        <div class="actions">
          <router-link
            :to="{name: 'Plans'}"
            class="btn btn-primary"
          >Visualizar planos
          </router-link>
        </div>
      </div>

      <loader v-if="loading"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/support/components/Loader.vue';
import SuccessCheckmark from '@/support/components/SuccessCheckmark.vue';
import currency from '@/support/filters/currency';

export default {
  name: 'Buy',

  data() {
    return {
      loading: false,
      finished: false,
      notFound: false,
      payment: null,
      elements: null,
      type: '',
      selectPaymentMethod: false,
      creditCard: '',
      paymentErrorMessage: '',
    };
  },

  methods: {
    async subscribe() {
      if (this.type === 's') {
        await this.subscribeWithCreditCard();
      } else {
        await this.subscribeWithElements();
      }
    },

    async subscribeWithElements() {
      this.loading = true;
      this.paymentErrorMessage = '';

      const stripeResponse = await this.$stripe.confirmPayment({
        elements: this.elements,
        redirect: 'if_required',
      });

      if (stripeResponse.error) {
        this.paymentErrorMessage = stripeResponse.error.message;
        this.loading = false;
        return;
      }

      await this.$store.dispatch('credits/subscribeIntentCheck', stripeResponse.paymentIntent.id);

      this.user.plan = {
        id: this.plan.id,
        name: this.plan.name,
        price: this.plan.price,
        price_per_consultation: this.plan.price_per_consultation,
        prepaid: false,
      };

      this.loading = false;
      this.finished = true;
    },

    async subscribeWithCreditCard() {
      if (this.creditCard === '') {
        this.selectPaymentMethod = true;
        return;
      }

      this.paymentErrorMessage = '';
      this.loading = true;

      try {
        const response = await this.$store.dispatch('credits/pay', {
          planId: this.$route.params.id,
          creditCard: this.creditCard,
        });

        if (response) {
          console.log('Erro: ', response);
        }

        this.user.plan = {
          id: this.plan.id,
          name: this.plan.name,
          price: this.plan.price,
          price_per_consultation: this.plan.price_per_consultation,
          prepaid: false,
        };

        this.finished = true;
      } catch (err) {
        const { data, status } = err.response;

        if (status === 422) {
          this.paymentErrorMessage = data.message;
        }
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    async type() {
      if (this.type === 'a') {
        this.loading = true;

        await this.$store.dispatch('credits/subscribeIntentCreate', this.$route.params.id);

        this.elements = this.$stripe.elements({ clientSecret: this.intent.clientSecret });
        this.payment = this.elements.create('payment');
        this.payment.mount('#payment-element');
        this.payment.on('ready', () => {
          this.loading = false;
        });
      } else if (this.payment) {
        this.payment.destroy();
      }
    },
  },

  computed: {
    ...mapState('credits', {
      intent: 'intent',
    }),
    ...mapState('auth', [
      'user',
    ]),
    ...mapState('credits', [
      'paymentMethods',
    ]),
    ...mapState('credits', [
      'plan',
    ]),
  },

  async mounted() {
    this.loading = true;


    await Promise.all([
      this.$store.dispatch('credits/paymentMethods'),
      this.$store.dispatch('credits/plan', this.$route.params.id),
    ]).catch(() => {
      this.notFound = true;
    });

    if (this.paymentMethods.length === 0) {
      this.type = 'a';
    } else {
      this.type = 's';
      this.loading = false;
    }
  },

  filters: {
    currency,
  },

  directives: {
  },

  beforeDestroy() {
    if (this.payment) {
      this.payment.destroy();
    }
  },

  components: {
    Loader,
    SuccessCheckmark,
  },
};
</script>

<style lang="scss" scoped>
  #credits-buy {
    > .card {
      > .body, .body form {
        > .alert {
          @apply mb-4;
        }

        > .choose-payment-method {
          > .paymentOptions {
            @apply flex;
            @apply flex-wrap;
            @apply gap-4;

            @screen md {
              @apply flex-no-wrap;
            }

            > .option {
              @apply w-full;
              @apply p-4;
              @apply border;
              @apply border-solid;
              @apply border-gray-400;
              @apply rounded;
              @apply text-grey-800;
              @apply font-bold;
              @apply cursor-pointer;

              @screen md {
                @apply w-auto;
                min-width: auto;
              }

              > .form-check-input {
                @apply relative;
                top: 1px;
              }

              > .icon {
                @apply ml-2;
                @apply relative;
                top: 2px;
              }
            }
          }

          &.-has-error {
            > .paymentOptions {
              > .option {
                @apply border-red-500;
              }
            }
          }
        }

        &.-finished {
          > .title {
            @apply text-2xl;
            @apply text-center;
            font-weight: bold;
            font-family: 'Roboto Slab', serif;
          }

          > .description {
            @apply pb-4 px-4;
            @apply text-sm;
            @apply text-center;
          }

          > .actions {
            @apply text-center;
            @apply mt-4;
            > .btn {
              @apply mx-1;
            }
          }
        }
      }
    }
  }
</style>
